import { useCallback } from 'react';

import type { Id } from '@e-socna/data-layer';

import { printSettingsForm2ApiMapper } from '../../../components/DocumentEditor/mappers/print-settings.form2api.mapper';
import type { OnSavePrintSettingsHandler } from '../../../components/DocumentEditor/types/props.type';

import { useUpdateQuotationPrintSettingsMutation } from './useUpdatePrintSettingsMutation.hook';
import { useQueryInvalidation } from './useQueryInvalidation.hook';

interface Params {
  readonly missionQuotationId: Id;
}

export const useSavePrintSettingsHandler = ({
  missionQuotationId,
}: Readonly<Params>) => {
  const { invalidateQueries } = useQueryInvalidation(missionQuotationId);
  const { mutateAsync: updatePrintSettings } =
    useUpdateQuotationPrintSettingsMutation();

  const onSavePrintSettings = useCallback<OnSavePrintSettingsHandler>(
    async (printSettings) => {
      await updatePrintSettings({
        printableId: missionQuotationId,
        printSettings: printSettingsForm2ApiMapper(printSettings),
      });
      invalidateQueries();
    },
    [invalidateQueries, missionQuotationId, updatePrintSettings],
  );

  return { onSavePrintSettings };
};
